module.exports = __webpack_public_path__ + "media/images/pages/i-belong/secondary_handbook-9ddeb6ef8e13dc7353681f031f36a577.svg";